import {
  TimeSheet
} from "@/API/api";
import {
  dateToYMD,
  ajax, checkFile, downloadFile
} from "@/util/util.js"
import {
  Message
} from "element-ui";
import moment from "moment"
import uploadMixin from '@/mixin/upload.js';
// import Toast from "@/components/popup/Toast";
export default {
  components:{
    // Toast,
 },
  mixins: [uploadMixin],
  data() {
    var valiNumberPass1 = (rule, value, callback) => { //包含小数的数字
      let reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g;
      let regfloat =  /^[+-]?(0|([1-9]\d*))(\.\d{1})?$/;
      console.log(value,'vaul')
      if (value === '') {
        callback(new Error('请输入工作时长（数字），只支持一位小数'));
      }else if (!reg.test(value)) {
        callback(new Error('请输入工作时长（数字），只支持一位小数'));
       } else if(!regfloat.test(value)){
        callback(new Error('只支持一位小数'));
      } else if (value >4) {
        callback(new Error('单条日报记录不超过4小时,单日工作时长累计不能超过12小时'));
      } else {
        callback();
      }
    };
    var valiYunzhouAddress=(rule, value, callback)=>{
      let str = 'https://drive.weixin.qq.com'
     let endString=value.slice(26).replace(/\s*/g,"")
     console.log(endString==='','endString-------')
      if(value === ''){
        callback(new Error('请输入企业微信云盘地址'));
      } else if (value.indexOf("https://drive.weixin.qq.com")!==0||endString===''){
        callback(new Error('请输入正确的企业微信云盘地址，例如https://drive.weixin.qq.com/xxx'));
      }else {
        callback();
      }
      // let reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g;
      // let regfloat =  /^[+-]?(0|([1-9]\d*))(\.\d{1})?$/;
    }
    return {
      modal1: false,
      btn: false,
      ruleForm: {
        workingDate: dateToYMD(new Date()),
        projectNumber: '', //项目名称
        type: '', //交付物类型
        jobDescription: '', //工作描述
        deliveryId: '', //交付物
        workingHours: null, //工作时长
        degreeOfDifficulty: '', //项目难度系数1
        deliverableVersion: '', //版本1
        yunzhouAddress: '', //企业微信云盘地址
        remark: '',
        userId: JSON.parse(localStorage.getItem("userInfo")).id,
        nameOfDeliverables: '',//交付物名称
        remark2:'',//文件名
      },
      rules: {
        workingDate: [{
          required: true,
          message: '请选择工作日期',
          trigger: 'change'
        },],
        projectNumber: [{
          required: true,
          message: '请选择项目名称',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择交付物类型',
          trigger: 'change'
        },],
        deliveryId: [{
          required: true,
          message: '请选择交付物',
          trigger: 'change'
        },],
        nameOfDeliverables: [{
          required: true,
          message: '请输入交付物名称',
          trigger: 'blur'
        }, { min: 1, max: 200, message: '长度在200个字符以内', trigger: 'blur' }],
        workingHours: [{
          required: true,
          validator: valiNumberPass1,
          trigger: 'blur change',
        }],
        yunzhouAddress: [{
          required: true,
          message: '请上传交付物',
          trigger: ['blur', 'change']
        } ],
      },
      allProjectName: [],
      difficultyCoefficient: [{
        value: '1',
        name: 'S'
      },
      {
        value: '2',
        name: 'A'
      },
      {
        value: '3',
        name: 'B'
      },
      {
        value: '4',
        name: 'C'
      }
      ],
      allVersion: [{
        value: '1',
        name: 'V1'
      },
      {
        value: '2',
        name: 'V2'
      },
      {
        value: '3',
        name: 'V3'
      },
      {
        value: '4',
        name: 'V4'
      },
      {
        value: '5',
        name: 'V5'
      },
      {
        value: '6',
        name: 'V6'
      },
      {
        value: '7',
        name: 'V7'
      },
      {
        value: '8',
        name: 'V8'
      },
      {
        value: '9',
        name: 'V9'
      },
      {
        value: '10',
        name: 'V10'
      }
      ],
      allHour: 0,
      tableData: [],
      allDeliverables: [],
      deliverablesTypeArr: [], //循环交付物类型
      deliverablesArr: [], //交付物
      bottomTable: [],
      titleIcon: require("@/assets/images/timesheet/add/title.png"),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      firstTitle:'',
      fileList: [],
      uploadFile:false,
      radio:'1',
      disabled:false,
      deliverablesList:[],
      // 剩余工时
      remainingManHourInput:null,
      // 预计工时
      manHourInput:null,
      // 项目ID 
      projectNow_id:null,
    }
  },
  methods: {
    // 获取待完成交付物
    getCompletedDeliverables(){
      let params={
        uId:JSON.parse(localStorage.getItem("userInfo")).id
      }
      return this.$http.post( TimeSheet.getCompletedDeliverables,this.qs.stringify(params)).then(res=>{
        this.deliverablesList = res.data.retData;
        let deliverablesId = Number(this.$route.query.deliverablesId)
        console.log(this.deliverablesList, 'this.deliverablesList', deliverablesId, !!deliverablesId)
        let chooseItem,index;
        for(var i=0; i<this.deliverablesList.length; i++){
          this.deliverablesList[i].sel=false;
          if (!!deliverablesId && deliverablesId == this.deliverablesList[i].deliverablesId){
            chooseItem = this.deliverablesList[i];
            index=i;
            console.log(this.deliverablesList[i].deliverablesId,'this.deliverablesList[i].deliverablesId')
            this.cehckchange(chooseItem,i)
          }
        }
        // console.log(this.$router.query, 'this.$router-----')
        // crossOriginIsolated.log(deliverablesId, 'deliverablesId');
        // //如果是从首页调过来
        // if (!!deliverablesId) { }
      });
    },
    filterAllProjectName(n,m){
      let ProjectName_Id =  this.allProjectName.filter(item=>item.id == n);
      return ProjectName_Id.length ? ProjectName_Id[0].id : m;
    },
    async cehckchange(t,idx){
      console.log(this.filterAllProjectName(t.projectId),'2333')
        const deliverablesArr = await this.getDeliverablesArr(t.deliverablesTypeId);
        let deliverablesArrData = deliverablesArr.data.retData;
        this.deliverablesArr=deliverablesArrData;
        this.ruleForm.deliveryId=null;
        this.firstTitle = t.labelId;
      this.projectNow_id = t.projectId;
      this.deliverablesList.map((item,n)=>{
        this.ruleForm = {
          workingDate: dateToYMD(new Date()),
          projectNumber: this.filterAllProjectName(t.projectId,t.projectName), //项目名称
          type: Number(t.deliverablesTypeId), //交付物类型
          nameOfDeliverables: t.deliverablesName, //交付物名称
          deliveryId: Number(t.deliverablesId), //交付物
          workingHours: null, //工作时长
          degreeOfDifficulty: '', //项目难度系数1
          deliverableVersion: '', //版本1
          yunzhouAddress: '', //企业微信云盘地址
          remark: '',
          jobDescription: '',
          userId: JSON.parse(localStorage.getItem("userInfo")).id,
          remark2:'',
        }
        return idx == n ? t.name : item.sel = false
      })
      if(t.sel){
        t.sel = false
      } else {
        t.sel = true
      }
      if(this.deliverablesList.findIndex(target=>target.sel===true)==-1){
        console.log(t,'验证通过')
        this.disabled = false;
        this.projectNow_id = null;
      }else {
        console.log('验证不通过')
        this.disabled = true;
        this.remainingManHourInput = t.remainingManHourInput;
        this.manHourInput = t.manHourInput;
      }
    },
    async homepageUpload(opt) {
      this.uploadFile=true;
      const path = await this.imgUpload(opt, 'allImgType');
      this.uploadFile = false;
      this.ruleForm.yunzhouAddress=path.url;
      this.ruleForm.remark2 = path.name;
      this.$forceUpdate();
    },
    lookDeliver() {
      let url = this.ruleForm.yunzhouAddress, name = this.ruleForm.remark2;
      if (url.indexOf("http://cloud.normcore.com/") >-1){
        window.open(url, "_blank")
      }else{
        let checkFileUrl = checkFile(url);
        if (checkFileUrl == 'video') {
          window.open(url, "_blank");

        } else {
          downloadFile(url, name)

        }
      }
    },
    removeUrl() {
      this.ruleForm.yunzhouAddress = '';
      this.ruleForm.remark2 = '';
      this.$forceUpdate();
    },

  
    async filterChange(item, i) {
      this.firstTitle=item.id;
      const deliverablesArr = await this.getDeliverablesArr(i.id);
      let deliverablesArrData = deliverablesArr.data.retData;
      this.deliverablesArr=deliverablesArrData;
      this.ruleForm.deliveryId=null;
    },
    //获取三级标题
    getDeliverablesArr(id){
      let params={
        id
      }
      return this.$http.post( TimeSheet.getAllGoods,this.qs.stringify(params));
    },
    //更改交付物类型
    changeType(val) {
      this.deliverablesArr = this.allDeliverables[val]
    },
    // 关闭弹窗
    cancel() {
      this.modal1 = false;
    },
    async onOk() {
      let api = this.PageType() == 'copy' ? TimeSheet.saveTimesheet : (this.PageType() ? TimeSheet.updateTimesheet : TimeSheet.saveTimesheet)
      if(this.PageType() == 'edit'){
        this.ruleForm['id'] = Number(this.$router.history.current.query.id)
      }
      console.log(this.ruleForm,'form')
      this.btn = true;
      console.log(typeof(this.ruleForm.projectNumber),'projectid-------')
      if(typeof(this.ruleForm.projectNumber) === 'string') {
        this.ruleForm.projectNumber = this.projectNow_id;
      }
      await this.$http.post(api, this.ruleForm).then((res) => {
        let _data = res.data;
        if (_data.retCode == 200 || _data.code == 200) {
          if(this.PageType()){
            this.$router.go(-1)
            if(this.PageType() == 'copy'){
              this.$message({
                message: '复制成功',
                type: 'success'
              });
            } else {
              this.$message({
                message: '编辑成功',
                type: 'success'
              });
            }
          } else {
            this.$message({
              message: '提交成功',
              type: 'success'
            });
          }
          delete this.ruleForm.type
          delete this.ruleForm.id
          this.modal1 = false;
          this.btn = false;
          this.ruleForm = {
            workingDate: dateToYMD(new Date()),
            projectNumber: '', //项目名称
            type: '', //交付物类型
            nameOfDeliverables: '', //交付物名称
            deliveryId: '', //交付物
            workingHours: null, //工作时长
            degreeOfDifficulty: '', //项目难度系数1
            deliverableVersion: '', //版本1
            yunzhouAddress: '', //企业微信云盘地址
            remark: '',
            jobDescription: '',
            userId: JSON.parse(localStorage.getItem("userInfo")).id,
            remark2:'',
          };
          this.deliverablesArr=[];
          this.$refs['ruleForm'].resetFields();
          this.getNowTime();
          //提交成功之后页面滚动到顶端
          document.scrollingElement.scrollTop = 0;
          this.getBottomTable();
          this.getCompletedDeliverables();
          this.disabled = false;
        } else {
          this.btn = false;
          this.$message.error(`${_data.retMsg}`);
          this.modal1 = false;
        }
      })
    },
    //TODO:改一下后台返回的数据
    submitForm(formName) {
      console.log(this.tableData,'tableData');
      console.log(this.ruleForm,'workingDate');
      let allWorkTime=Number(this.allHour)+Number(this.ruleForm.workingHours);
      this.$refs[formName].validate((valid, obj) => {
        console.log(valid,'valid')
        if (valid) {
          if (allWorkTime > 12) {
            this.$message.error("单日工作时长累计不能超过12小时");
            return
          }else if(Number(this.remainingManHourInput) < Number(this.ruleForm.workingHours)&&this.disabled) {
            console.log(this.remainingManHourInput,this.ruleForm.workingHours,'工时----')
            this.$message.error("工作时长不能大于项目交付物剩余投入工时");
            return
          }
          console.log(Number(this.remainingManHourInput),Number(this.ruleForm.workingHours),this.deliverablesList.findIndex(target=>target.sel===true)==1,'工时----')
          this.modal1 = true;
        }else {  
          console.log(obj, '1')
          for (const prop in obj) {
            if (
              !this.ruleForm[prop] ||
              (Array.isArray(this.ruleForm[prop]) &&
                !this.ruleForm[prop].length)
            ) {
              Message.warning({
                message: obj[prop][0].message,
              });
              break;
            }
          }
          return false;
        }
      });
    },
    //TODO:改一下后台返回的数据
    // 交付物类型
    getdeliverables() {
      this.$http.post(TimeSheet.getDeliverables).then((res) => {
        let _data = res.data.retData;
        this.deliverablesTypeArr = _data;

      })
        .catch(err => {
          this.$message.error(`${err.toString()}`);

        })

    },
    //TODO:改一下后台返回的数据
    getProjects() {
      let params={
        userId:JSON.parse(localStorage.getItem("userInfo")).id
      }
      this.$http.get(TimeSheet.getProject, {params}).then((res) => {
        const _data = res.data;
        if (_data.retCode == 200) {
          this.allProjectName = _data.retData
        } else if (_data.retCode == -1) {
          this.$cookie.delete("token");
          this.$router.push("/");
          this.$message.error(`身份验证失败，请重新登录`);
        } else {
          this.$message.error(`${_data.retMsg}`);
        }

      }).catch(err => {
        this.$message.error(`${err.toString()}`);
      })


    },
    getBottomTable() {
      let params = {
        uId: JSON.parse(localStorage.getItem("userInfo")).id
      }
      this.$http.post(TimeSheet.getDaylist, this.qs.stringify(params)).then((res) => {
        const _data = res.data;
        if (_data.retCode == 200) {
          this.allHour = 0;
          this.tableData = _data.retData;
          console.log(_data.retData,'retData------')
          if(this.PageType() == 'edit' && this.PageType()){
            _data.retData.filter((t, i) => {
              let arr =  (t.id == Number(this.$router.history.current.query.id) ? 0 : t.workHours)
              this.allHour += Number(arr);
              console.log(this.allHour,'allHour')
            })
          } else {
            _data.retData.map((t, i) => {
              this.allHour += Number(t.workHours);
              console.log(this.allHour,'allHour')
            })
          }
        } else if (_data.retCode == -1) {
          this.$cookie.delete("token");
          this.$router.push("/");
          this.$message.error(`身份验证失败，请重新登录`);
        } else {
          this.$message.error(`${_data.retMsg}`);
        }

      }).catch(err => {
        this.$message.error(`${err.toString()}`);
      })
    },
    //判断当前时间有没有超过十一点，超过十一点九部让他补之前的timesheet
    getNowTime() {
      let beginTime=new Date();
      const time1 = moment(beginTime, 'HH:mm:ss');
      const time2 = moment('15:00:00', 'HH:mm:ss');
      const time3 = moment('06:00:00','HH:mm:ss');
      //time 当前时间 time2 11点 isBefore=ture 当前时间在十五点之前 可以填昨天的
      let isBefore= moment(time1).isBefore(time2);
      //time 当前时间 time3 6点 isBefore=ture 当前时间在6点之前 默认选择时间为昨天否则今天
      let isBeforetwo=moment(time1).isBefore(time3);
      //当前时间小于十一点
      if (isBefore) {
        console.log('hhhhhisBefore')
        this.pickerOptions = {
          disabledDate(time) {
            // return time.getTime() < (Date.now() - 1000 * 60 * 60 * 24 * 2);
            // 获取当前时间戳
            const curTime = new Date().getTime();
            // 获取三天前的时间戳
            const startDate = curTime - (2 * 3600 * 24 * 1000);
            // 当日期选择面板的日期小于startDate ，或者大于curTime 时，返回true,返回true则不可选
            if (time < startDate || time > curTime) {
              return true
            }
          },
        };
      } else {
        //当前时间大于11点
        this.pickerOptions = {
          disabledDate(time) {
            // return time.getTime() < (Date.now() - 1000 * 60 * 60 * 24);
            const times = new Date(new Date().toLocaleDateString()).getTime() + 1 * 8.64e7 - 1
            return time.getTime() < Date.now() - 8.64e7 || time.getTime() > times// 如果没有后面的-8.64e7就是不可以选择今天的
          },
        };

      }
      if(isBeforetwo){
        //当前时间小于六点
        const yesterday =dateToYMD(moment().subtract(1, 'days'));
        this.ruleForm.workingDate=yesterday;
        console.log(yesterday,'====')
      }else{
        //当前时间大于六点
        this.ruleForm.workingDate= dateToYMD(new Date());
      }
    },
    PageType(){
      return this.$router.history.current.query.type
    },
    copy(){
      console.log('objtype',this.PageType())
      if(!this.PageType()){
        return
      }
      let params = {
        Id: this.$router.history.current.query.id
      }
      this.$http.post(TimeSheet.tsById, this.qs.stringify(params)).then(async(res) => {
        let _data = res.data;
        if(_data.retCode == 200) {
          // start
          const deliverablesArr = await this.getDeliverablesArr(_data.retData.deliverableTypeId);
          let deliverablesArrData = deliverablesArr.data.retData;
          this.deliverablesArr=deliverablesArrData;
          this.ruleForm.deliveryId=null;
          this.firstTitle = _data.retData.labelId;
          // end
          this.ruleForm = {
            workingDate: dateToYMD(new Date()),
            projectNumber:  _data.retData.projectNumber, //项目名称
            type: _data.retData.deliverableTypeId, //交付物类型
            jobDescription: _data.retData.jobDescription, //工作描述
            deliveryId: _data.retData.deliverablesId, //交付物
            workingHours: _data.retData.workHours, //工作时长
            degreeOfDifficulty: String(_data.retData.difficulty), //项目难度系数1
            deliverableVersion: String(_data.retData.deliverablesVersion), //版本1
            yunzhouAddress: _data.retData.yunZhouAddress, //企业微信云盘地址
            remark: _data.retData.remark,
            userId: JSON.parse(localStorage.getItem("userInfo")).id,
            nameOfDeliverables: _data.retData.nameOfDeliverables,//交付物名称
            remark2: _data.retData.remark2
          }
          console.log(_data.retData.remark2,'_data.retData.remark2')
        }
      })
    },
    getdeliverablesId(){
    
    }
  },
  mounted() {
        this.getNowTime();
        this.getdeliverables();
        this.getProjects();
        this.getBottomTable();
        this.copy();
        this.getCompletedDeliverables();
        this.getdeliverablesId()
  },
}
